import { render } from "./ProfileListPlaceholder.vue?vue&type=template&id=5d8bba71&scoped=true"
import script from "./ProfileListPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProfileListPlaceholder.vue?vue&type=script&lang=js"

import "./ProfileListPlaceholder.vue?vue&type=style&index=0&id=5d8bba71&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8bba71"]])

export default __exports__